<template>
  <div>
    <!-- src="@/assets/images/No-data.svg"  -->
    <img
      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/3.jpg"
      alt=""
      class="w-2/5 m-auto"
    />
    <p class="font-semibold text-center text-xl">{{ title }}</p>
  </div>
  <!-- test -->
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "There are currently no items",
    },
  },
};
</script>
